import Axios from 'axios';
import { Message } from 'element-ui';
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from './requestHelper';

// 创建axios实例
const instance = Axios.create({
  // 请求根路径
  baseURL: process.env.VUE_APP_BASEURL,
  // 请求超时时间
  timeout: 60000,
  // 允许携带cookie
  withCredentials: true,
});
// 默认配置
const defaultConfig = { showLoading: true };

// 请求拦截器
instance.interceptors.request.use(
  (config: any) => {
    if (config.showLoading === undefined) {
      config.showLoading = defaultConfig.showLoading;
    }
    if (config.showLoading) {
      showFullScreenLoading();
    }
    if (localStorage.Authorization) {
      config.headers.Authorization = localStorage.Authorization;
    }
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _: Date.now(),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 处理返回状态码
const handleCode = (code: number): void => {
  switch (code) {
    case 400:
      break;
    case 401:
      localStorage.removeItem('Authorization');
      localStorage.removeItem('CurrentUser');
      location.href = `${
        process.env.VUE_APP_PASSPORT_LOGINURL
      }?returnUrl=${encodeURIComponent(location.href)}`;
      break;
    case 500:
      break;
  }
};

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const { headers, data, config } = response;
    const configAny: any = config;
    if (configAny.showLoading) {
      tryHideFullScreenLoading();
    }
    if (headers.Authorization) {
      localStorage.Authorization = headers.Authorization;
    }
    handleCode(data.code);
    return response;
  },
  // 服务器状态码不是200的情况
  (error) => {
    tryHideFullScreenLoading();
    // 请求错误时
    console.log('request:', error);
    // 判断请求超时
    if (
      error.code === 'ECONNABORTED' &&
      error.message.indexOf('timeout') !== -1
    ) {
      Message.error('请求超时!');
    }
    handleCode(error.response.status);
    return Promise.reject(error);
  }
);

export default instance;
